import { makeStyles } from "tss-react/mui";
import { MiBuildHouseAlt } from "@miplatform/assets";
import {
  MiIcon,
  MiInputTextbox,
  MiPlaceholderArea,
  MiSectionHeader,
} from "@miplatform/components";
import { mdiMagnify } from "@mdi/js";

export function AreaTemplates({ open }: AreaTemplatesProps) {
  const { classes, theme } = useStyles();

  if (!open) {
    return null;
  }

  return (
    <>
      <MiSectionHeader
        variant="text"
        title="Select Area Template"
        subtitle="Select from the list of area templates"
      />
      <MiInputTextbox
        className={classes.searchBox}
        placeholder="Search for Area Templates"
        textfieldProps={{
          startAdornment: (
            <MiIcon path={mdiMagnify} color={theme.palette.grey.medium} />
          ),
        }}
      />
      <MiPlaceholderArea
        text="No Area Templates to Display"
        helperText="Tip: Start from scratch, add your area, then click Save Area Template."
        iconComponent={<img src={MiBuildHouseAlt} alt="House Icon" />}
        containerStyle={{
          backgroundColor: theme.palette.primary.light,
          margin: theme.spacing(1),
        }}
      />
    </>
  );
}

const useStyles = makeStyles()((theme) => ({
  searchBox: {
    padding: theme.spacing(1),
  },
}));

interface AreaTemplatesProps {
  open: boolean;
}
